<template>
    <Navbar></Navbar>
    <div class="contact-hero">
        <div class="contact-us-title">
            商务合作
        </div>
        <div class="contact-hero-inner">
            <div class="contact-hero-card">
                <div class="contact-hero-inner-item">
                    <div class="contact-hero-company">蜂巢汽车科技集团有限公司</div>
                    <div class="contact-hero-addr">地址：河北省保定市莲池区东二环东盛路75号</div>
                </div>
            </div>
            <div class="contact-hero-map">
                <div class="map-img" @click="openMap">
                    <img class="pc-pad" data-src="/assets/contact/map.jpg" alt="contact map">
                    <img class="mb-only" data-src="/assets/contact/map-m.jpg" alt="contact map">
                </div>
            </div>
        </div>
    </div>
    <div v-if="showMapPopup" class="map-popup-mask" @click.self="closeMapPopup">
        <div class="map-popup">
            <div class="map-popup-title">选择地图应用</div>
            <div class="map-popup-item" @click="goAmapApp">高德地图</div>
            <div class="map-popup-item" @click="goBaiduMapApp">百度地图</div>
            <div class="map-popup-item" @click="goTencentMap">腾讯地图</div>
            <div class="map-popup-cancel" @click="closeMapPopup">取消</div>
        </div>
    </div>
    <div class="contact-us">
        <div class="contact-us-list">
            <div class="contact-us-item">
                <div class="contact-us-t1">
                    电子产品销售
                </div>
                <div class="contact-us-d">
                    <div>
                        地&nbsp;&nbsp;&nbsp;址：江苏省张家港经济技术开发区彩虹路668号
                    </div>
                    <div>
                        邮&nbsp;&nbsp;&nbsp;箱：chenhong@finestauto.com
                    </div>

                    <div>
                        电&nbsp;&nbsp;&nbsp;话：13663123760
                    </div>
                </div>
            </div>

            <div class="contact-us-item">
                <div class="contact-us-t1">
                    动力总成销售
                </div>
                <div class="contact-us-d">
                    <div>
                        地&nbsp;&nbsp;&nbsp;址：河北省保定市莲池区东二环东盛路75号
                    </div>
                    <div>
                        邮&nbsp;&nbsp;&nbsp;箱：fcdlxsz@gwm.cn
                    </div>

                    <div>
                        电&nbsp;&nbsp;&nbsp;话：18633299228、18633299403
                    </div>
                </div>
            </div>
        </div>

    </div>

    <Footer></Footer>
</template>

<script setup>
import { ref } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
const isPc = ref(window.innerWidth > 768);
const showMapPopup = ref(false);

// 目标地址：蜂巢汽车科技集团有限公司 保定市莲池区东二环东盛路75号
const targetAddr = "蜂巢汽车科技集团有限公司";
const lat = 38.88822;
const lon = 115.52144;
const openMap = () => {
    if (!isPc.value) {
        showMapPopup.value = true;
    }
}
const closeMapPopup = () => {
    showMapPopup.value = false;
}

// 高德APP跳转
const goAmapApp = () => {
    closeMapPopup();
    const appUrl = `amapuri://route/plan/?sid=&slat=&slon=&sname=&dlat=${lat}&dlon=${lon}&dname=${encodeURIComponent(targetAddr)}&dev=0&m=0`;
    const webUrl = `https://amap.com/navi?dest=${lat},${lon}&destname=${encodeURIComponent(targetAddr)}`;
    window.location.href = appUrl;
    setTimeout(() => {
        if (document.visibilityState === 'visible') { // 页面还在前台才跳转网页
            window.location.href = webUrl;
        }
    }, 2000);
}

// 百度地图APP跳转
const goBaiduMapApp = () => {
    closeMapPopup();
    const bdLat = 38.89412;
    const bdLon = 115.52781;
    const appUrl = `baidumap://map/direction?mode=driving&dest-name=${encodeURIComponent(targetAddr)}&dest-lat=${bdLat}&dest-lon=${bdLon}`;
    const webUrl = `https://api.map.baidu.com/direction?origin=&destination=name:${encodeURIComponent(targetAddr)}|latlng:${bdLat},${bdLon}&mode=driving&output=html&src=your_web_name`;
    window.location.href = appUrl;
    setTimeout(() => {
        if (document.visibilityState === 'visible') { // 页面还在前台才跳转网页
            window.location.href = webUrl;
        }
    }, 2000);
}

// 腾讯地图app 修复缺失跳转
const goTencentMap = () => {
    closeMapPopup();
    const scheme = `qqmap://map/routeplan?type=drive&fromcoord=CurrentLocation&to=${encodeURIComponent(targetAddr)}&tocoord=${lat},${lon}`;
    const webUrl = `https://apis.map.qq.com/uri/v1/routeplan?type=drive&to=${encodeURIComponent(targetAddr)}&tocoord=${lat},${lon}`;
    window.location.href = scheme;
    setTimeout(() => {
        if (document.visibilityState === 'visible') { // 页面还在前台才跳转网页
            window.location.href = webUrl;
        }
    }, 2000);
}


</script>

<script>
export const pageConfig = {
    title: '商务合作 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'contact-us.html'
};

import { createApp } from 'vue';
import App from './contact-us.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./contact-us.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped>
.contact-hero {
    padding: 2.1rem 1.56rem 0rem;
    width: calc(100% - 3.12rem);

    .contact-us-title {
        font-size: 0.4rem;
        font-weight: 500;
        color: #000;
        margin-bottom: 0.4rem;
    }

    .contact-hero-inner {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
    }

    .contact-hero-card {
        width: 49.3%;
        border-radius: 0.25rem;
        background: #F6F8FA;
        display: flex;
        flex-direction: column;

        .contact-hero-inner-item {
            padding: 0.58rem 0.44rem;
        }

        .contact-hero-title {
            font-size: 0.5rem;
            font-weight: 500;
            margin-bottom: 0.3rem;
        }

        .contact-hero-company {
            font-size: 0.28rem;
            font-weight: 700;
            color: #000;
            margin-bottom: 0.56rem;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 0.38rem;
                height: 0.02rem;
                background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                bottom: -0.2rem;
                left: 0;
            }
        }

        .contact-hero-addr {
            font-size: 0.16rem;
            color: #999;
            line-height: 0.3rem;
        }
    }

    .contact-hero-map {
        width: 49.3%;

        .map-img {
            width: 100%;
            height: 100%;
            border-radius: 0.25rem;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
}

.contact-us {
    padding: 0.25rem 1.56rem 1.4rem;
    width: calc(100% - 3.12rem);

    .contact-us-title {
        font-size: 0.4rem;
        font-weight: 500;
        color: #000;
        margin-bottom: 0.4rem;
    }

    .contact-us-list {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        margin-bottom: 1.4rem;
    }

    .contact-us-item {
        width: 50%;
        border-radius: 0.25rem;
        height: 3rem;
        background: #F6F8FA;
        padding: 0.58rem 0.44rem;

        .contact-us-t1 {
            font-size: 0.25rem;
            font-weight: 600;
            color: #000;
            margin-bottom: 0.56rem;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 0.38rem;
                height: 0.02rem;
                background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                bottom: -0.2rem;
                left: 0;
            }
        }

        .contact-us-d {
            font-size: 0.16rem;
            color: #999;
            line-height: 0.3rem;
            font-weight: 400
        }
    }

    .contact-us-flex {
        width: 100%;
        display: flex;
        align-items: center;
        border-radius: 0.25rem;
        overflow: hidden;

        .img-box {
            width: 50%;
        }

        .contact-us-item {
            width: 50%;
            padding: 0.58rem 0.68rem;
            border-radius: unset;
        }
    }
}

// 地图选择弹窗样式
.map-popup-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.map-popup {
    width: 100%;
    background: #fff;
    border-radius: 0.24rem 0.24rem 0 0;
    overflow: hidden;
}

.map-popup-title {
    text-align: center;
    font-size: 0.28rem;
    padding: 0.3rem 0;
    font-weight: 500;
    border-bottom: 1px solid #eee;
}

.map-popup-item {
    text-align: center;
    font-size: 0.26rem;
    padding: 0.32rem 0;
    border-bottom: 1px solid #eee;
    cursor: pointer;
}

.map-popup-cancel {
    text-align: center;
    font-size: 0.26rem;
    padding: 0.32rem 0;
    color: #666;
    background: #f7f7f7;
    cursor: pointer;
}


@media (max-width: 768px) {
    .contact-hero {
        padding: 2.02rem 0.45rem 0;
        width: calc(100% - 0.9rem);

        .contact-hero-inner {
            flex-direction: column-reverse;
            background: #F6F8FA;

            .contact-hero-card {
                width: 100%;

                .contact-hero-addr {
                    font-size: 0.2rem;
                    color: #000;
                }
            }

            .contact-hero-map {
                width: 100%;
            }
        }
    }

    .contact-us {
        padding: 0.3rem 0.45rem 0;
        width: calc(100% - 0.9rem);

        .contact-us-list {
            flex-direction: column;
            gap: 0.3rem;
        }

        .contact-us-item {
            width: calc(100% - 1.36rem);
            padding: 0.58rem 0.68rem;
            height: auto;
            .contact-us-t1 { 
                font-size: 0.28rem;
            }
            .contact-us-d { 
                font-size: 0.2rem;
                font-weight: 400;
                color: #000;
            }
        }
    }
}
</style>